import React from 'react'
import {getTaskTypeIconParser} from '../shared/enums/task-type-icon-parser'

export default React.createClass({

  render: function () {
    let show =[];
    let icon, name, newName;
    let imgsrc;
    if(this.props.data.length !== 0){
        for(let i = 0; i < this.props.data.length; i++){
          icon = (getTaskTypeIconParser(this.props.data[i].data.taskType))
          name = (getTaskTypeIconParser(this.props.data[i].data.taskType))
          newName = name.prettify
          imgsrc = icon.iconsrc
          show.push(
            <div key={'h' + i} className='col-xs-12 pull-down-xs-2 card-icon-right task-type center small no-text'>
              <div role='presentation' key={i} className={`clickable img-responsive center-block ${imgsrc}-circle`} onClick={() => this.props.open(this.props.data[i].data)} style={{width: 33, height: 35, float:'left', marginLeft: 10, marginRight: 10}}/>
              <img  role="presentation" key={i} className='clickable' onClick={() => this.props.open(this.props.data[i].data)} style={{width: 33, height: 35, float:'left', marginLeft: 10, marginRight: 10}} src={imgsrc}/>
              <p onClick={() => this.props.open(this.props.data[i].data)} style={{float: 'left', fontSize: 20, marginTop: 5}}>{newName}</p>
            </div>
            );
      }
    }else{
        show = <div key={'h'} className='col-xs-12 pull-down-xs-2'>
                    <p style={{float: 'left', fontSize: 20}}>No tasks today</p>
            </div>
    }


    return (

      <div>
        <div className='row task-show'>
            {show}
        </div>
      </div>
    )
  }
})




// WEBPACK FOOTER //
// ./src/components/schedule/calendar-tasks-display.jsx